import { NgModule } from '@angular/core';
import { ApiAuthorizationRoutingModule } from './api-authorization-routing.module';

@NgModule({
    imports: [ApiAuthorizationRoutingModule],
})
export class ApiAuthorizationModule { }
